import React, { useRef, useState } from "react";
import PropTypes from "prop-types";

const TermoModal = ({
  show,
  onClose,
  onAccept,
  loading = false,
  userNeedsToAcceptTerm = false,
  title = "Termo de Confidencialidade",
}) => {
  const termoRef = useRef(null);
  const [canAcceptTerm, setCanAcceptTerm] = useState(false);

  const handleScroll = () => {
    if (termoRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = termoRef.current;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
      setCanAcceptTerm(isAtBottom);
    }
  };

  const handleClose = () => {
    setCanAcceptTerm(false);
    if (termoRef.current) {
      termoRef.current.scrollTop = 0;
    }
    onClose();
  };

  if (!show) return null;

  return (
    <div className="termo-overlay">
      <div className="termo-modal">
        {/* HEADER */}
        <div className="termo-header">
          <h2>{title}</h2>
          <p className="mt-2">
            Antes de continuar, é necessário ler e concordar com os termos
            abaixo.
          </p>
        </div>

        {/* CONTEÚDO */}
        <div ref={termoRef} onScroll={handleScroll} className="termo-content">
          <h3>
            Política de Privacidade e Responsabilidade dos Usuários do Sistema
            ConeCta-SP
          </h3>

          <p>
            A Fundação Oncocentro do Estado de São Paulo (FOSP), responsável
            pelo desenvolvimento e gerenciamento do Sistema ConeCta-SP
            (SisConeCta), está comprometida com a proteção e o uso responsável
            da base de dados, bem como dos dados pessoais que identificam os
            usuários deste sistema.
          </p>

          <p>
            A base de dados do SisConeCta é composta pelos dados registrados nos
            sistemas oficiais do Ministério da Saúde (Siscolo, Sismama e Siscan)
            e pelos dados registrados no sistema utilizado na gestão municipal.
          </p>

          <p>
            Respeitando a Lei Geral de Proteção de Dados (LGPD - Lei nº
            13.709/2018, alterada pela Lei nº 13.853/2019), ferramentas são
            utilizadas para preservar a confidencialidade das informações
            registradas no SisConeCta e os dados dos usuários do sistema.
          </p>

          <h4>Com relação aos usuários do sistema</h4>

          <p>
            O usuário é identificado pelo seu nome completo, CPF, e-mail, código
            CNES da unidade de saúde a que está vinculado e registro de senha.
            Os dados de login e senha são de uso pessoal e intransferível.
          </p>

          <p>
            Ao se logar ao SisConeCta, o sistema identifica o endereço IP do
            usuário, sistema operacional, provedor de internet, data, horário e
            duração do acesso.
          </p>

          <p>
            As interações do usuário no SisConeCta são armazenadas de forma
            segura e poderão ser utilizadas para fins de auditoria,
            responsabilização ou cumprimento das obrigações legais.
          </p>

          <h4>Com relação às obrigações do Usuário</h4>

          <ul>
            <li>
              Manter a confidencialidade, integridade e segurança das
              informações;
            </li>
            <li>
              Não divulgar qualquer informação acessada durante a utilização do
              sistema;
            </li>
            <li>
              Estar ciente de que o descumprimento das obrigações acarretará
              sanções disciplinares, civis e/ou penais;
            </li>
            <li>Declarar ciência integral do conteúdo deste documento.</li>
          </ul>

          <p>
            Esta Política pode ser revisada periodicamente para adequação às
            normas vigentes.
          </p>

          <p>
            Em caso de dúvidas, entre em contato com:
            juridico@fosp.saude.sp.gov.br
          </p>
        </div>

        {/* FOOTER */}
        <div className="termo-footer">
          {!canAcceptTerm && userNeedsToAcceptTerm && (
            <div className="termo-warning">
              Role até o final do documento para habilitar o aceite.
            </div>
          )}

          <div className="termo-actions">
            {userNeedsToAcceptTerm ? (
              <>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={handleClose}
                >
                  Recusar
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={!canAcceptTerm || loading}
                  onClick={onAccept}
                >
                  {loading ? (
                    <>
                      <span className="spinner"></span>
                      Processando...
                    </>
                  ) : (
                    "Aceitar e continuar"
                  )}
                </button>
              </>
            ) : (
              <button
                type="button"
                className="btn btn-outline-rpimary"
                onClick={handleClose}
              >
                Fechar
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

TermoModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func,
  loading: PropTypes.bool,
  userNeedsToAcceptTerm: PropTypes.bool,
  title: PropTypes.string,
};

export default TermoModal;
